import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RadioFilterOption } from './radio-and-datepicker-filter.constants';

@Injectable({
  providedIn: 'root'
})
export class RadioAndDatepickerFilterDOS {
  private _isCustomCheckedSubject = new BehaviorSubject<boolean>(false);
  readonly isCustomChecked$ = this._isCustomCheckedSubject.asObservable();

  private _selectedPeriodSubject = new BehaviorSubject<RadioFilterOption>(RadioFilterOption.All);
  readonly selectedPeriod$ = this._selectedPeriodSubject.asObservable();

  updateIsCustomChecked(data: boolean): void {
    return this._isCustomCheckedSubject.next(data);
  }

  getIsCustomCheckedSnapshot(): boolean {
    return this._isCustomCheckedSubject.value;
  }

  updateSelectedPeriod(data: RadioFilterOption): void {
    return this._selectedPeriodSubject.next(data);
  }

  getSelectedPeriodSnapshot(): RadioFilterOption {
    return this._selectedPeriodSubject.value;
  }
}
